'use client';
import React from 'react';

const EmailIcon = () => {
	return (
		<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_395_472)">
				<path d="M0.354492 4.60433L8.41178 9.56266H8.58887L16.6462 4.60433M16.6462 2.8335V14.521H16.292C14.167 14.1668 10.6253 13.9897 8.50033 13.9897C6.37533 13.9897 2.83366 14.1668 0.708659 14.521H0.354492V2.8335C2.47949 2.47933 6.37533 2.30225 8.50033 2.30225C10.6253 2.30225 14.5212 2.47933 16.6462 2.8335Z" stroke="#6B724B" />
			</g>
			<defs>
				<clipPath id="clip0_395_472">
					<rect width="17" height="17" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export default React.memo(EmailIcon);